<div *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>

<div *ngIf="!isLoading" style="height: 100%;">

    <button mat-icon-button class="matdialog-close-btn" [mat-dialog-close]="true">
        <mat-icon class="close-icon">close</mat-icon>
    </button>

    <h1 mat-dialog-title>Checkout</h1>
    <div matßdialogßcontent>

        <div class="content">

            <mat-horizontal-stepper [linear]="true" #stepper>
                <mat-step [stepControl]="firstFormGroup">
                    <form [formGroup]="firstFormGroup">
                        <ng-template matStepLabel>Lieferadresse</ng-template>

                        <div class="row">


                            <mat-radio-group formControlName="addrType" required>
                                <mat-radio-button value="auto">Rechnungsadresse verwenden</mat-radio-button>
                                <mat-radio-button value="alt">Alternative Lieferadresse:</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="row">

                            <div class="col-6">
                                <div id="checkout_adr"></div>
                                <!-- {{rechnungAdr}} -->
                            </div>
                            <div class="col-6" *ngIf="firstFormGroup.value.addrType=='alt'">
                                <mat-form-field>
                                    <mat-label>Name</mat-label>

                                    <input matInput placeholder="Last name, First name" formControlName="firstCtrl"
                                        required>
                                </mat-form-field>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-3 offset-9">
                                <button mat-button matStepperNext>Weiter</button>
                            </div>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="secondFormGroup" label="Zahlung">
                    <form [formGroup]="secondFormGroup">
                        
                        
                        <div id="checkout_paymentterm" style="font-size: 40px;"></div>
                        <!--<mat-form-field>
                            <mat-label>Zahlungsbedingung</mat-label>
                            
                            <input matInput id="checkout_paymentterm" formControlName="secondCtrl">
                        </mat-form-field>-->
                    
                        <div>
                            <button mat-button matStepperPrevious>Zurück</button>
                            <button mat-button matStepperNext>Weiter</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step>
                    <ng-template matStepLabel>Zusammenfassung</ng-template>
                    <p>You are now done.</p>
                    <div>
                        <div class="checkout_footer_l">
                            <button mat-button matStepperPrevious>Zurück</button>
                            <button mat-button (click)="stepper.reset()">Abbruch</button>
                        </div>

                        <div class="checkout_footer_r">
                            <button id="btn_request" color="accent" mat-raised-button mat-dialog-close="do_request">Angebot anfragen</button>
                            <button id="btn_order" color="accent" mat-raised-button mat-dialog-close="do_order">Bestellung aufgeben</button>
                        </div>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>

        </div>
    </div>




</div>